import type { TeamRegistrationField } from '@/types/tournament/game';
import { RegistrationContext } from '@/types/tournament/game';
import { TeamMemberRole } from '@/types/team';

/**
 * Get active fields for a specific role and context
 * Filters teamRegistrationFields based on roleValidationRules[role][context].active
 */
export const getActiveFields = (
  allFields: TeamRegistrationField[],
  role: TeamMemberRole,
  context: RegistrationContext,
): TeamRegistrationField[] => {
  return allFields.filter(field => {
    const roleRules = field.roleValidationRules?.[role];
    const contextRule = roleRules?.[context];
    return contextRule?.active === true;
  });
};

/**
 * Get mandatory status for a field based on role and context
 * Returns true if roleValidationRules[role][context].mandatory is true
 */
export const getFieldMandatoryStatus = (
  field: TeamRegistrationField,
  role: TeamMemberRole,
  context: RegistrationContext,
): boolean => {
  const roleRules = field.roleValidationRules?.[role];
  const contextRule = roleRules?.[context];
  return contextRule?.mandatory ?? false;
};

/**
 * Get active general form fields for a specific context
 * Filters teamRegistrationFields based on generalFormRules[context].active
 */
export const getActiveGeneralFields = (
  allFields: TeamRegistrationField[],
  context: RegistrationContext,
): TeamRegistrationField[] => {
  return allFields.filter(field => {
    const generalRule = field.generalFormRules?.[context];
    return generalRule?.active === true;
  });
};

/**
 * Get mandatory status for a general form field based on context
 * Returns true if generalFormRules[context].mandatory is true
 */
export const getGeneralFieldMandatoryStatus = (
  field: TeamRegistrationField,
  context: RegistrationContext,
): boolean => {
  const generalRule = field.generalFormRules?.[context];
  return generalRule?.mandatory ?? false;
};
